import { StructureObjectField } from '../../enums/structure-object';

import titleIcon from '../../../images/icons/structure-object/text-icon.svg';
import usersIcon from '../../../images/icons/structure-object/users-icon.svg';
import clockIcon from '../../../images/icons/structure-object/oclock-icon.svg';
import descIcon from '../../../images/icons/structure-object/description-icon.svg';
import userIcon from '../../../images/icons/structure-object/user-icon.svg';
import priorityIcon from '../../../images/icons/structure-object/priority-icon.svg';
import stageIcon from '../../../images/icons/structure-object/stage-icon.svg';
import sellingIcon from '../../../images/icons/dark/sellings-icon.svg';
import folderIcon from '../../../images/icons/dark/projects-icon.svg';

export const structureTask: StructureObjectField[] = [
    {
        key: 'name',
        label: 'Назва',
        order: 1,
        icon: titleIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'createdAt',
        label: 'Дата створення',
        order: 2,
        icon: clockIcon,
        visible: true,
    },
    {
        key: 'deadline',
        label: 'Дедлайн',
        order: 3,
        icon: clockIcon,
        isRequired: true,
        visible: true,
    },
    {
        key: 'status',
        label: 'Статус',
        order: 4,
        icon: stageIcon,
        visible: true,
    },
    {
        key: 'priority',
        label: 'Пріорітет',
        order: 5,
        icon: priorityIcon,
        visible: true,
    },
    {
        key: 'createdBy',
        label: 'Ким створено',
        order: 6,
        icon: userIcon,
        visible: true,
    },
    {
        key: 'description',
        label: 'Опис',
        order: 7,
        icon: descIcon,
        visible: true,
    },
    {
        key: 'usersEmails',
        label: 'Виконавці',
        order: 8,
        icon: usersIcon,
        isRequired: true,
        visible: true,
    },
];

export const structureTaskOther: StructureObjectField[] = [
    {
        key: 'project',
        label: 'Проєкт',
        order: 1,
        icon: folderIcon,
        visible: true,
    },
    {
        key: 'selling',
        label: 'Продажі',
        order: 2,
        icon: sellingIcon,
        visible: true,
    },
]